module.exports = __webpack_public_path__ + "img/parcel.99d8d477.svg";